import debounce from 'lodash/debounce';
import { RefObject, useCallback, useEffect, useState } from 'react';

export const useIsSingleLine = (
    ref: RefObject<HTMLElement>,
    textWidth: RefObject<number>,
) => {
    const [isSingleLine, setIsSingleLine] = useState(false);
    const [isResizing, setIsResizing] = useState(false);

    const updateIsSingleLine = useCallback(() => {
        setIsResizing(true);
        const element = ref.current;
        const elementWidth = element?.getBoundingClientRect().width;

        if (!elementWidth || !textWidth || !textWidth.current) {
            if (textWidth.current === 0) {
                setIsSingleLine(true);
            }
            return;
        }

        setIsSingleLine(elementWidth >= textWidth.current);
        setIsResizing(false);
    }, [ref, textWidth, setIsSingleLine]);

    useEffect(() => {
        updateIsSingleLine();
    }, [ref, updateIsSingleLine]);

    useEffect(() => {
        const handleResize = debounce(updateIsSingleLine, 250);

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { isSingleLine, isResizing };
};
